import { config } from 'data';
import { statisticsService } from 'services';
import { useQuery } from 'hooks';
import { StatisticsVolumesParams } from 'types/services';

const useStatisticsVolumesQuery = (params: StatisticsVolumesParams) => useQuery({
  queryKey: [config.STATISTICS_VOLUMES_QUERY_KEY, params],
  queryFn: () => statisticsService.getVolumes(params),
});

export default useStatisticsVolumesQuery;
